{
  "three-acts": {
    "name": "Drei Akte",
    "summary": "Einführung, Konfrontation und Auflösung: die Struktur der meisten Romane und Filme.",
    "bestFor": "Jedes Genre und ein erster Entwurf, den du einfach halten möchtest.",
    "metaTitle": "Erzählvorlage in drei Akten — Musael",
    "metaDescription": "Einführung, Konfrontation und Auflösung: die Struktur der meisten Romane und Filme. Für jedes Genre und einen einfachen ersten Entwurf.",
    "acts": [
      {
        "title": "Akt I: Einführung",
        "synopsis": "Wer die Hauptfigur ist, was sie will und welches Ereignis ihr normales Leben beendet.",
        "chapters": [
          {
            "title": "Die gewohnte Welt",
            "synopsis": "Die Hauptfigur zu Hause, mit dem Wunsch und der Schwäche, die die Geschichte auf die Probe stellt.",
            "scenes": [
              {
                "title": "Anfangsbild",
                "synopsis": "Eine Momentaufnahme der Hauptfigur, bevor sich etwas verändert."
              },
              {
                "title": "Der Aufhänger",
                "synopsis": "Etwas Kleines, aber Seltsames kündigt Schwierigkeiten an."
              }
            ]
          },
          {
            "title": "Das auslösende Ereignis",
            "synopsis": "Das Ereignis, das die Hauptfigur nicht ignorieren kann.",
            "scenes": [
              {
                "title": "Auslösendes Ereignis",
                "synopsis": "Das Problem tritt auf und verschwindet nicht wieder."
              },
              {
                "title": "Zögern",
                "synopsis": "Die Hauptfigur zögert, und wir sehen, was sie verlieren könnte."
              }
            ]
          },
          {
            "title": "Die Schwelle überschreiten",
            "synopsis": "Die Hauptfigur legt sich fest; es gibt keinen einfachen Weg zurück.",
            "scenes": [
              {
                "title": "Die Entscheidung",
                "synopsis": "Die Hauptfigur entscheidet sich zu handeln und lässt das Vertraute hinter sich."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt II: Konfrontation",
        "synopsis": "Die Hauptfigur versucht es, scheitert und lernt, während immer mehr auf dem Spiel steht.",
        "chapters": [
          {
            "title": "Es steht mehr auf dem Spiel",
            "synopsis": "Neue Regeln, Verbündete und Gegner; die ersten Siege haben ihren Preis.",
            "scenes": [
              {
                "title": "Erste Prüfung",
                "synopsis": "Die Hauptfigur begegnet der neuen Welt und versteht sie teilweise falsch."
              },
              {
                "title": "Verbündete und Gegner",
                "synopsis": "Wer hilft, wer im Weg steht und warum."
              }
            ]
          },
          {
            "title": "Der Mittelpunkt",
            "synopsis": "Eine Umkehr, die verändert, worum es in der Geschichte geht.",
            "scenes": [
              {
                "title": "Mittelpunkt",
                "synopsis": "Ein scheinbarer Sieg oder eine scheinbare Niederlage; die Hauptfigur reagiert nicht mehr nur, sondern übernimmt die Führung."
              }
            ]
          },
          {
            "title": "Alles fällt auseinander",
            "synopsis": "Die Gegenseite rückt näher, und die Schwäche kommt die Hauptfigur teuer zu stehen.",
            "scenes": [
              {
                "title": "Die Schlinge zieht sich zu",
                "synopsis": "Jeder Plan stößt auf Widerstand; Beziehungen bekommen Risse."
              },
              {
                "title": "Alles ist verloren",
                "synopsis": "Der Tiefpunkt: Das Ziel scheint endgültig unerreichbar."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt III: Auflösung",
        "synopsis": "Die Hauptfigur verändert sich, stellt sich der letzten Prüfung und findet in einen neuen Alltag.",
        "chapters": [
          {
            "title": "Der Höhepunkt",
            "synopsis": "Die letzte Konfrontation, gewonnen durch die Erkenntnis aus Akt II.",
            "scenes": [
              {
                "title": "Der letzte Plan",
                "synopsis": "Die Hauptfigur bündelt das Gelernte und unternimmt einen letzten Versuch."
              },
              {
                "title": "Höhepunkt",
                "synopsis": "Die entscheidende Konfrontation."
              }
            ]
          },
          {
            "title": "Der neue Alltag",
            "synopsis": "Was sich verändert hat, für die Hauptfigur und für die Welt.",
            "scenes": [
              {
                "title": "Schlussbild",
                "synopsis": "Ein Spiegel des Anfangsbilds, der zeigt, wie weit die Hauptfigur gekommen ist."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "Die Heldenreise",
    "summary": "Zwölf Stationen vom Ruf zum Abenteuer bis zur Heimkehr, gegliedert in Aufbruch, Initiation und Rückkehr.",
    "bestFor": "Fantasy, Abenteuer und Questen.",
    "metaTitle": "Erzählvorlage für die Heldenreise — Musael",
    "metaDescription": "Zwölf Stationen vom Ruf zum Abenteuer bis zur Heimkehr: Aufbruch, Initiation und Rückkehr. Für Fantasy, Abenteuer und Questen.",
    "acts": [
      {
        "title": "Aufbruch",
        "synopsis": "Die Hauptfigur verlässt die bekannte Welt.",
        "chapters": [
          {
            "title": "Die gewohnte Welt",
            "synopsis": "Die Hauptfigur vor dem Abenteuer: Zuhause, Gewohnheiten und das, was fehlt.",
            "scenes": [
              {
                "title": "Die gewohnte Welt",
                "synopsis": "Die Hauptfigur vor dem Abenteuer: Zuhause, Gewohnheiten und das, was fehlt."
              }
            ]
          },
          {
            "title": "Der Ruf zum Abenteuer",
            "synopsis": "Eine Herausforderung oder Nachricht stört die gewohnte Welt.",
            "scenes": [
              {
                "title": "Der Ruf zum Abenteuer",
                "synopsis": "Eine Herausforderung oder Nachricht stört die gewohnte Welt."
              }
            ]
          },
          {
            "title": "Die Verweigerung des Rufs",
            "synopsis": "Angst oder Pflicht hält die Hauptfigur zurück.",
            "scenes": [
              {
                "title": "Die Verweigerung des Rufs",
                "synopsis": "Angst oder Pflicht hält die Hauptfigur zurück."
              }
            ]
          },
          {
            "title": "Begegnung mit dem Mentor",
            "synopsis": "Jemand gibt Rat, bildet aus oder überreicht ein Geschenk.",
            "scenes": [
              {
                "title": "Begegnung mit dem Mentor",
                "synopsis": "Jemand gibt Rat, bildet aus oder überreicht ein Geschenk."
              }
            ]
          },
          {
            "title": "Die erste Schwelle überschreiten",
            "synopsis": "Die Hauptfigur betritt die besondere Welt.",
            "scenes": [
              {
                "title": "Die erste Schwelle überschreiten",
                "synopsis": "Die Hauptfigur betritt die besondere Welt."
              }
            ]
          }
        ]
      },
      {
        "title": "Initiation",
        "synopsis": "Prüfungen in der besonderen Welt und die große Bewährungsprobe.",
        "chapters": [
          {
            "title": "Prüfungen, Verbündete und Gegner",
            "synopsis": "Die Hauptfigur lernt die Regeln der neuen Welt.",
            "scenes": [
              {
                "title": "Prüfungen, Verbündete und Gegner",
                "synopsis": "Die Hauptfigur lernt die Regeln der neuen Welt."
              }
            ]
          },
          {
            "title": "Annäherung an die tiefste Höhle",
            "synopsis": "Vorbereitungen auf die zentrale Gefahr.",
            "scenes": [
              {
                "title": "Annäherung an die tiefste Höhle",
                "synopsis": "Vorbereitungen auf die zentrale Gefahr."
              }
            ]
          },
          {
            "title": "Die entscheidende Prüfung",
            "synopsis": "Eine Krise auf Leben und Tod; etwas in der Hauptfigur stirbt.",
            "scenes": [
              {
                "title": "Die entscheidende Prüfung",
                "synopsis": "Eine Krise auf Leben und Tod; etwas in der Hauptfigur stirbt."
              }
            ]
          },
          {
            "title": "Die Belohnung",
            "synopsis": "Die Hauptfigur erlangt den Schatz, das Wissen oder die Versöhnung.",
            "scenes": [
              {
                "title": "Die Belohnung",
                "synopsis": "Die Hauptfigur erlangt den Schatz, das Wissen oder die Versöhnung."
              }
            ]
          }
        ]
      },
      {
        "title": "Rückkehr",
        "synopsis": "Der Heimweg, eine letzte Prüfung und das, was die Hauptfigur mitbringt.",
        "chapters": [
          {
            "title": "Der Rückweg",
            "synopsis": "Die Hauptfigur macht sich auf den Heimweg, oft verfolgt.",
            "scenes": [
              {
                "title": "Der Rückweg",
                "synopsis": "Die Hauptfigur macht sich auf den Heimweg, oft verfolgt."
              }
            ]
          },
          {
            "title": "Auferstehung",
            "synopsis": "Eine letzte Prüfung, in der alles Gelernte zum Einsatz kommt.",
            "scenes": [
              {
                "title": "Auferstehung",
                "synopsis": "Eine letzte Prüfung, in der alles Gelernte zum Einsatz kommt."
              }
            ]
          },
          {
            "title": "Rückkehr mit dem Elixier",
            "synopsis": "Die Hauptfigur kehrt verändert heim und hat etwas weiterzugeben.",
            "scenes": [
              {
                "title": "Rückkehr mit dem Elixier",
                "synopsis": "Die Hauptfigur kehrt verändert heim und hat etwas weiterzugeben."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "Gliederung in fünfzehn Handlungsschritte",
    "summary": "Der Ablaufplan aus dem Drehbuchschreiben: fünfzehn Wendepunkte in drei Akten.",
    "bestFor": "Straffe, marktgängige Handlungen mit klaren Wendepunkten.",
    "metaTitle": "Vorlage mit fünfzehn Handlungsschritten — Musael",
    "metaDescription": "Der Ablaufplan aus dem Drehbuchschreiben: fünfzehn Wendepunkte in drei Akten. Für straffe, marktgängige Handlungen mit klaren Wendepunkten.",
    "acts": [
      {
        "title": "Akt I",
        "synopsis": "Die frühere Welt und die Entscheidung, sie zu verlassen.",
        "chapters": [
          {
            "title": "Anfangsbild",
            "synopsis": "Die Hauptfigur und die Welt vor der Geschichte.",
            "scenes": [
              {
                "title": "Anfangsbild",
                "synopsis": "Die Hauptfigur und die Welt vor der Geschichte."
              }
            ]
          },
          {
            "title": "Das Thema wird genannt",
            "synopsis": "Jemand sagt, worum es wirklich geht; die Hauptfigur erkennt es noch nicht.",
            "scenes": [
              {
                "title": "Das Thema wird genannt",
                "synopsis": "Jemand sagt, worum es wirklich geht; die Hauptfigur erkennt es noch nicht."
              }
            ]
          },
          {
            "title": "Einführung",
            "synopsis": "Das Leben der Hauptfigur, die Menschen darin und das, was sich ändern muss.",
            "scenes": [
              {
                "title": "Einführung",
                "synopsis": "Das Leben der Hauptfigur, die Menschen darin und das, was sich ändern muss."
              }
            ]
          },
          {
            "title": "Katalysator",
            "synopsis": "Das Ereignis, das die Geschichte in Gang setzt.",
            "scenes": [
              {
                "title": "Katalysator",
                "synopsis": "Das Ereignis, das die Geschichte in Gang setzt."
              }
            ]
          },
          {
            "title": "Zögern",
            "synopsis": "Die Hauptfigur weiß nicht, was sie tun soll.",
            "scenes": [
              {
                "title": "Zögern",
                "synopsis": "Die Hauptfigur weiß nicht, was sie tun soll."
              }
            ]
          },
          {
            "title": "Übergang in den zweiten Akt",
            "synopsis": "Die Hauptfigur wählt einen neuen Weg.",
            "scenes": [
              {
                "title": "Übergang in den zweiten Akt",
                "synopsis": "Die Hauptfigur wählt einen neuen Weg."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt II",
        "synopsis": "Das Versprechen der Prämisse, dann der Absturz.",
        "chapters": [
          {
            "title": "Nebenhandlung",
            "synopsis": "Eine zweite Handlung, oft eine Beziehung, die das Thema trägt.",
            "scenes": [
              {
                "title": "Nebenhandlung",
                "synopsis": "Eine zweite Handlung, oft eine Beziehung, die das Thema trägt."
              }
            ]
          },
          {
            "title": "Spiel und Spaß",
            "synopsis": "Die Prämisse wird eingelöst: das, wofür die Leser gekommen sind.",
            "scenes": [
              {
                "title": "Spiel und Spaß",
                "synopsis": "Die Prämisse wird eingelöst: das, wofür die Leser gekommen sind."
              }
            ]
          },
          {
            "title": "Mittelpunkt",
            "synopsis": "Ein scheinbarer Sieg oder eine scheinbare Niederlage erhöht den Einsatz.",
            "scenes": [
              {
                "title": "Mittelpunkt",
                "synopsis": "Ein scheinbarer Sieg oder eine scheinbare Niederlage erhöht den Einsatz."
              }
            ]
          },
          {
            "title": "Die Gegner rücken näher",
            "synopsis": "Zweifel im Inneren, Druck von außen.",
            "scenes": [
              {
                "title": "Die Gegner rücken näher",
                "synopsis": "Zweifel im Inneren, Druck von außen."
              }
            ]
          },
          {
            "title": "Alles ist verloren",
            "synopsis": "Das Gegenteil des Mittelpunkts: der tiefste Moment.",
            "scenes": [
              {
                "title": "Alles ist verloren",
                "synopsis": "Das Gegenteil des Mittelpunkts: der tiefste Moment."
              }
            ]
          },
          {
            "title": "Die dunkle Nacht der Seele",
            "synopsis": "Die Hauptfigur trauert um das Verlorene und erkennt die Lehre daraus.",
            "scenes": [
              {
                "title": "Die dunkle Nacht der Seele",
                "synopsis": "Die Hauptfigur trauert um das Verlorene und erkennt die Lehre daraus."
              }
            ]
          }
        ]
      },
      {
        "title": "Akt III",
        "synopsis": "Die Erkenntnis wird umgesetzt.",
        "chapters": [
          {
            "title": "Übergang in den dritten Akt",
            "synopsis": "Eine neue Idee aus der Nebenhandlung eröffnet einen Weg.",
            "scenes": [
              {
                "title": "Übergang in den dritten Akt",
                "synopsis": "Eine neue Idee aus der Nebenhandlung eröffnet einen Weg."
              }
            ]
          },
          {
            "title": "Finale",
            "synopsis": "Die Hauptfigur bringt das Zerbrochene in Ordnung und ist dauerhaft verändert.",
            "scenes": [
              {
                "title": "Finale",
                "synopsis": "Die Hauptfigur bringt das Zerbrochene in Ordnung und ist dauerhaft verändert."
              }
            ]
          },
          {
            "title": "Abschlussbild",
            "synopsis": "Die Welt danach, als Spiegel des Anfangsbilds.",
            "scenes": [
              {
                "title": "Abschlussbild",
                "synopsis": "Die Welt danach, als Spiegel des Anfangsbilds."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Sieben-Punkte-Struktur",
    "summary": "Plane vom Ende rückwärts: Aufhänger, Wendungen, Druckpunkte, Mittelpunkt und Auflösung.",
    "bestFor": "Schreibende, die zuerst das Ende kennen.",
    "metaTitle": "Erzählvorlage mit sieben Punkten — Musael",
    "metaDescription": "Vom Ende rückwärts planen: Aufhänger, Wendungen, Druckpunkte, Mittelpunkt und Auflösung. Für Schreibende, die zuerst das Ende kennen.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Aufhänger",
            "synopsis": "Der Ausgangszustand, das Gegenteil der Auflösung.",
            "scenes": [
              {
                "title": "Aufhänger",
                "synopsis": "Der Ausgangszustand, das Gegenteil der Auflösung."
              }
            ]
          },
          {
            "title": "Handlungswende 1",
            "synopsis": "Der Konflikt beginnt und drängt die Hauptfigur zum Handeln.",
            "scenes": [
              {
                "title": "Handlungswende 1",
                "synopsis": "Der Konflikt beginnt und drängt die Hauptfigur zum Handeln."
              }
            ]
          },
          {
            "title": "Druckpunkt 1",
            "synopsis": "Die Gegenfigur übt Druck aus; die Hauptfigur muss handeln.",
            "scenes": [
              {
                "title": "Druckpunkt 1",
                "synopsis": "Die Gegenfigur übt Druck aus; die Hauptfigur muss handeln."
              }
            ]
          },
          {
            "title": "Mittelpunkt",
            "synopsis": "Die Hauptfigur wechselt vom Reagieren zum Handeln.",
            "scenes": [
              {
                "title": "Mittelpunkt",
                "synopsis": "Die Hauptfigur wechselt vom Reagieren zum Handeln."
              }
            ]
          },
          {
            "title": "Druckpunkt 2",
            "synopsis": "Alles läuft gründlich schief; der Plan scheitert.",
            "scenes": [
              {
                "title": "Druckpunkt 2",
                "synopsis": "Alles läuft gründlich schief; der Plan scheitert."
              }
            ]
          },
          {
            "title": "Handlungswende 2",
            "synopsis": "Die Hauptfigur erhält das letzte fehlende Stück zum Sieg.",
            "scenes": [
              {
                "title": "Handlungswende 2",
                "synopsis": "Die Hauptfigur erhält das letzte fehlende Stück zum Sieg."
              }
            ]
          },
          {
            "title": "Auflösung",
            "synopsis": "Der Endzustand, die Antwort auf den Aufhänger.",
            "scenes": [
              {
                "title": "Auflösung",
                "synopsis": "Der Endzustand, die Antwort auf den Aufhänger."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Vier Bewegungen, die auf einer Wendung statt auf einem Konflikt aufbauen.",
    "bestFor": "Literarische Prosa, Kurzgeschichten und ruhige, figurengetragene Bücher.",
    "metaTitle": "Erzählvorlage Kishōtenketsu — Musael",
    "metaDescription": "Vier Bewegungen mit einer Wendung statt einem Konflikt. Für literarische Prosa, Kurzgeschichten und ruhige, figurengetragene Bücher.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki: Einführung",
            "synopsis": "Die Figuren und ihre Welt, in Ruhe.",
            "scenes": [
              {
                "title": "Einführung",
                "synopsis": "Wer, wo und wie der Alltag aussieht."
              }
            ]
          },
          {
            "title": "Shō: Entwicklung",
            "synopsis": "Die Situation vertieft sich, noch ohne Wendung.",
            "scenes": [
              {
                "title": "Entwicklung",
                "synopsis": "Wir lernen die Figuren besser kennen; kleine Dinge verändern sich."
              }
            ]
          },
          {
            "title": "Ten: Wendung",
            "synopsis": "Ein unerwartetes Element verändert unseren Blick auf alles.",
            "scenes": [
              {
                "title": "Die Wendung",
                "synopsis": "Etwas Neues, scheinbar Unverbundenes kommt hinzu."
              }
            ]
          },
          {
            "title": "Ketsu: Zusammenführung",
            "synopsis": "Die Teile fügen sich zu einem neuen Verständnis zusammen.",
            "scenes": [
              {
                "title": "Zusammenführung",
                "synopsis": "Wendung und Geschichte treffen aufeinander; die Bedeutung verschiebt sich."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Krimi",
    "summary": "Ein Verbrechen, Ermittlungen mit Hinweisen und falschen Fährten und eine faire Auflösung.",
    "bestFor": "Kriminalromane, Detektivgeschichten und Cosy-Krimis.",
    "metaTitle": "Erzählvorlage für Krimis — Musael",
    "metaDescription": "Ein Verbrechen, Hinweise, falsche Fährten und eine faire Auflösung. Für Kriminalromane, Detektivgeschichten und Cosy-Krimis.",
    "acts": [
      {
        "title": "Das Verbrechen",
        "synopsis": "Etwas stimmt nicht, und jemand muss herausfinden, warum.",
        "chapters": [
          {
            "title": "Die Entdeckung",
            "synopsis": "Das Verbrechen oder das Verschwinden.",
            "scenes": [
              {
                "title": "Die Leiche",
                "synopsis": "Das Verbrechen wird entdeckt; erste Eindrücke und erste Fragen."
              },
              {
                "title": "Die ermittelnde Person",
                "synopsis": "Wer ermittelt und warum der Fall dieser Person wichtig ist."
              }
            ]
          }
        ]
      },
      {
        "title": "Die Ermittlungen",
        "synopsis": "Hinweise, Verdächtige und falsche Fährten.",
        "chapters": [
          {
            "title": "Verdächtige",
            "synopsis": "Alle mit einem Motiv und einem Alibi.",
            "scenes": [
              {
                "title": "Befragungen",
                "synopsis": "Jede verdächtige Person erhält einen Grund zu lügen."
              },
              {
                "title": "Der erste Hinweis",
                "synopsis": "Eine Tatsache, die später wichtig wird; spiele fair mit den Lesern."
              }
            ]
          },
          {
            "title": "Falsche Fährten",
            "synopsis": "Die Ermittlungen gehen in die falsche Richtung.",
            "scenes": [
              {
                "title": "Eine falsche Fährte",
                "synopsis": "Die Beweise deuten auf die falsche Person."
              },
              {
                "title": "Eskalation",
                "synopsis": "Ein zweites Verbrechen oder eine Bedrohung erhöht den Einsatz."
              }
            ]
          },
          {
            "title": "Die verborgene Wahrheit",
            "synopsis": "Die ermittelnde Person erkennt, was schon immer da war.",
            "scenes": [
              {
                "title": "Das fehlende Stück",
                "synopsis": "Ein kleines Detail lässt die bisherigen Hinweise zusammenpassen."
              }
            ]
          }
        ]
      },
      {
        "title": "Die Enthüllung",
        "synopsis": "Die Lösung und ihr Preis.",
        "chapters": [
          {
            "title": "Die Lösung",
            "synopsis": "Jeder Hinweis wird erklärt.",
            "scenes": [
              {
                "title": "Die Enthüllung",
                "synopsis": "Die schuldige Person wird benannt und die Schlussfolgerung erläutert."
              },
              {
                "title": "Die Folgen",
                "synopsis": "Gerechtigkeit oder ihr Ausbleiben und das, was der ermittelnden Person bleibt."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "Liebesgeschichte",
    "summary": "Zwei Menschen, was sie trennt und was nötig ist, damit sie sich füreinander entscheiden.",
    "bestFor": "Liebesromane und Liebesgeschichten an jedem Schauplatz.",
    "metaTitle": "Erzählvorlage für Liebesgeschichten — Musael",
    "metaDescription": "Zwei Menschen, was sie trennt und wie sie sich füreinander entscheiden. Für Liebesromane und Liebesgeschichten an jedem Schauplatz.",
    "acts": [
      {
        "title": "Sich verlieben",
        "synopsis": "Sie begegnen sich, wehren sich und beginnen, sich zu verlieben.",
        "chapters": [
          {
            "title": "Die Begegnung",
            "synopsis": "Das erste Treffen, mit dem Funken und dem Hindernis.",
            "scenes": [
              {
                "title": "Begegnung",
                "synopsis": "Die beiden Hauptfiguren treffen sich; etwas am anderen geht ihnen unter die Haut."
              },
              {
                "title": "Widerstand",
                "synopsis": "Warum es nicht klappen kann: Ziele, Verletzungen oder Umstände."
              }
            ]
          },
          {
            "title": "Sich näherkommen",
            "synopsis": "Zusammengeführt durch die Umstände, erkennen sie einander wirklich.",
            "scenes": [
              {
                "title": "Zufällig zusammen",
                "synopsis": "Eine Situation hält sie beieinander."
              },
              {
                "title": "Der erste echte Moment",
                "synopsis": "Ein Blick darauf, wer der andere wirklich ist."
              }
            ]
          }
        ]
      },
      {
        "title": "Zweifeln",
        "synopsis": "Bindung, dann die Angst, die sie zerbricht.",
        "chapters": [
          {
            "title": "Der Mittelpunkt",
            "synopsis": "Sie geben ihren Gefühlen nach.",
            "scenes": [
              {
                "title": "Bindung",
                "synopsis": "Ein Kuss, ein Geständnis oder ein Versprechen."
              }
            ]
          },
          {
            "title": "Der Bruch",
            "synopsis": "Die alte Verletzung oder das äußere Hindernis gewinnt, vorerst.",
            "scenes": [
              {
                "title": "Zweifel",
                "synopsis": "Alte Ängste kehren zurück."
              },
              {
                "title": "Die Trennung",
                "synopsis": "Sie gehen auseinander, beide überzeugt, recht zu haben."
              }
            ]
          }
        ]
      },
      {
        "title": "Sich entscheiden",
        "synopsis": "Wachstum, eine große Geste und eine gemeinsame Zukunft.",
        "chapters": [
          {
            "title": "Zusammen",
            "synopsis": "Beide verändern sich genug, um den anderen zu verdienen.",
            "scenes": [
              {
                "title": "Die große Geste",
                "synopsis": "Eine der beiden Figuren riskiert alles, um ihre Veränderung zu zeigen."
              },
              {
                "title": "Glücklich bis ans Lebensende",
                "synopsis": "Oder vorerst glücklich: die Zukunft, die sie wählen."
              }
            ]
          }
        ]
      }
    ]
  }
}
